
import {getAuth} from 'firebase/auth';
import {ResourceViewMarker} from '../../hooks/useResourceVisit';
// src/core-pages/team-stats/TeamStatsPage.js — imports
import LinkedRecordEntry from '../../components/team-library/LinkedRecordEntry';
import React, { useEffect, useMemo, useState } from "react";
import {Plus} from "lucide-react";
import StatisticsHeaderActions from "../../components/planning/StatisticsHeaderActions";
import TeamStatsBrowser, {emptyStatsFilters,filterTeamStats} from "../../components/planning/TeamStatsBrowser";
import TeamStatsRecordCard from "../../components/planning/TeamStatsRecordCard";
import { useParams, useLocation } from "react-router-dom";

import { db} from "../../Security/firebase-config";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,

} from "firebase/firestore";

import UploadScoreDialog from "./UploadScoreDialog";

import LinkVodDialog from "../../components/core-components/LinkVodDialog";

import CustomAlert from "../../components/core-components/CustomAlert";
import LinkedDeletionDialog from '../../components/core-components/LinkedDeletionDialog';

import LoginTeamGate from "../../components/core-components/LoginTeamGate";

import "./TeamStatsPage.css";

export default function TeamStatsPage({ fallbackTeamId = null }) {
  const { teamId: paramTeamId } = useParams();
  const location = useLocation();
  const targetMatchId = new URLSearchParams(location.search).get("match");
  const teamId = paramTeamId || new URLSearchParams(location.search).get("teamId") || fallbackTeamId;

  const [linkingMatch, setLinkingMatch] = useState(null);
  const [matchToDelete, setMatchToDelete] = useState(null);
  const [customAlert, setCustomAlert] = useState(null);

  const [matches, setMatches] = useState([]);
  const [teamEvents, setTeamEvents] = useState([]);
  const [teamRoles, setTeamRoles] = useState({});
  const [openUpload, setOpenUpload] = useState(()=>new URLSearchParams(location.search).get('libraryAction')==='add');
  const [editing, setEditing] = useState(null);

  const [statsFilters,setStatsFilters] = useState({...emptyStatsFilters});





  const showAlert = (message, type = "info") => {
    setCustomAlert({
      message,
      type,
      position: "top",
    });
  };

  useEffect(() => {
    if (!teamId) return undefined;

    const unsub = onSnapshot(
      doc(db, "teams", teamId),
      (snap) => {
        const team = snap.exists() ? snap.data() || {} : {};

        setTeamRoles(team.teamRoles || {});
        setTeamEvents(Array.isArray(team.events) ? team.events : []);
      },
      (error) => {
        console.error("TeamStatsPage team listener failed:", error);
        showAlert("Could not load team details. Refresh the page and try again.", "error");
      }
    );

    return () => unsub();
  }, [teamId]);

  // live matches
  useEffect(() => {
    if (!teamId) return undefined;
    const q = query(
      collection(db, "teams", teamId, "matches"),
      orderBy("matchDate", "desc")
    );
    const unsub = onSnapshot(
      q,
      (snap) => {
        setMatches(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      },
      (error) => {
        console.error("TeamStatsPage matches listener failed:", error);
        showAlert("Could not load team stats matches. Refresh the page and try again.", "error");
      }
    );
    return () => unsub();
  }, [teamId]);

  useEffect(() => {
    if (!targetMatchId) return undefined;
    setStatsFilters({...emptyStatsFilters});
    const timer = setTimeout(() => document.getElementById(`stats-${targetMatchId}`)?.scrollIntoView({block:"center", behavior:"smooth"}), 100);
    return () => clearTimeout(timer);
  }, [targetMatchId, matches]);

  const filtered = useMemo(()=>filterTeamStats(matches,statsFilters),[matches,statsFilters]);
  if (!teamId) {
    return <LoginTeamGate />;
  }

  const closeDialog = () => {
    setOpenUpload(false);
    setEditing(null);
  };




  return (
    <LinkedRecordEntry teamId={teamId} kind="stats"><div className="ts-container">
      <div className="ts-page">
        <TeamStatsBrowser headerControls filteredCount={filtered.length} matches={matches} value={statsFilters} onChange={setStatsFilters}/>
        <StatisticsHeaderActions><button className="StatsRecords__add" type="button" onClick={()=>setOpenUpload(true)}><Plus size={17}/>Add Team Stats</button></StatisticsHeaderActions>



        <section className="ts-grid" aria-label="Team Stats match records" tabIndex={0}>
          {!filtered.length && <p>{matches.length ? "No Team Stats match your search or filters." : "No Team Stats records yet."}</p>}
          {filtered.map((m) => (
            <article key={m.id} id={`stats-${m.id}`} className="ts-card" style={new URLSearchParams(location.search).get("match") === m.id ? {outline: "2px solid var(--clr22bbd7)"} : undefined}>
              <ResourceViewMarker uid={getAuth().currentUser?.uid} teamId={teamId} resourceId={m.id}/>
              <TeamStatsRecordCard match={m} teamId={teamId} events={teamEvents} roles={teamRoles} onEdit={()=>setEditing(m)} onDelete={()=>setMatchToDelete(m)}/>
            </article>
          ))}
        </section>

        {openUpload && (
          <UploadScoreDialog key="new" teamId={teamId} onClose={closeDialog} />
        )}

        {editing && (
          <UploadScoreDialog
            key={editing.id}
            teamId={teamId}
            existing={editing}
            onAttachExisting={() => setLinkingMatch(editing)}
            onClose={closeDialog}
          />
        )}

        {linkingMatch && (
          <LinkVodDialog
            teamId={teamId}
            mode="teamstats-to-reviewmatch"
            initialTeamStatsMatchId={linkingMatch.id}
            onClose={() => setLinkingMatch(null)}
          />
        )}

        {matchToDelete && (
          <LinkedDeletionDialog teamId={teamId} anchor={{kind:'stats',statsId:matchToDelete.id}} onCancel={() => setMatchToDelete(null)} onDeleted={() => {setMatchToDelete(null); showAlert('Selected linked items deleted.', 'success');}} />
        )}

        {customAlert && (
          <CustomAlert
            message={customAlert.message}
            type={customAlert.type}
            position={customAlert.position}
            onClose={() => setCustomAlert(null)}
          />
        )}
      </div>


    </div></LinkedRecordEntry>
  );
}
